import { Achievement, UserAchievement } from '@vae/server/dist/client'
import { useEffect, useRef } from 'react'
import { awardPointsAnimation } from '../utils/animation/awardPointsAnimation'
import { AchievementsHook } from './useAchievements'

interface ElementProps {
	pointsContainer: HTMLDivElement
	points: number
	setPointsAwarded: AchievementsHook['setPointsAwarded']
	userAchievement: UserAchievement & { achievement: Achievement }
}

interface AchievementAnimationProps {
	pointsAwarded: boolean
	isCompleted: boolean
	elementProps: ElementProps
}

export const useAwardPointsAnimation = ({
	pointsAwarded,
	isCompleted,
	elementProps,
}: AchievementAnimationProps) => {
	const pointsBadgeRef = useRef<HTMLDivElement>(null)
	const hasAnimatedRef = useRef(false)

	useEffect(() => {
		if (!pointsAwarded && isCompleted && !hasAnimatedRef.current && pointsBadgeRef.current) {
			hasAnimatedRef.current = true
			awardPointsAnimation(pointsBadgeRef.current, elementProps.pointsContainer)
			elementProps.setPointsAwarded(elementProps.userAchievement.id)
		}
	}, [
		pointsAwarded,
		isCompleted,
		elementProps.pointsContainer,
		elementProps.points,
		elementProps.setPointsAwarded,
		elementProps.userAchievement.id,
	])

	return pointsBadgeRef
}
